import React from 'react'
import PropTypes from 'prop-types'
import Card from 'components/Card'

import { useComponentId } from 'utils/optimizely'
import { CarouselCardWrapper } from './CarouselCard.style'
import { fixAudiences } from '../../../utils/audiences'

const CarouselCard = (props) => {
  const {
    isLast,
    elementId,
    image,
    currentSlide,
    article,
    product,
    service,
    offer,
    info,
    brand,
    index,
    isSmall,
    onClick,
    hasImage,
    onclickProductModal,
    enableImageFadeIn,
    rtl,
    isColoredBg,
    background = 'Green',
  } = props

  const isActive = index === currentSlide
  const audiences = product ? product.audiences : ''
  const hasAudiences = !!audiences

  let cardData

  if (product) {
    cardData = {
      currentSlide,
      image,
      product,
      index,
      type: 'Carousel_Products',
      title: product.brand,
      onclickProductModal,
      enableImageFadeIn,
      isColoredBg,
    }
  }

  if (article) {
    cardData = {
      image,
      article,
      onClick,
      type: 'Carousel_Article',
      title: article.heading,
      enableImageFadeIn,
    }
  }

  if (service) {
    cardData = {
      image,
      service,
      onClick,
      type: 'Carousel_Services',
      title: service.heading,
      enableImageFadeIn,
    }
  }

  if (offer) {
    cardData = {
      image,
      offer,
      isSmall,
      onClick,
      type: 'Carousel_Offer',
      title: offer.headline,
      componentHeadline: offer.componentHeadline,
      enableImageFadeIn,
      rtl,
    }
  }

  if (info) {
    cardData = {
      info,
      onClick,
      type: 'Carousel_Info_Cards',
      title: info.heading,
      enableImageFadeIn,
      background,
    }
  }

  if (brand) {
    cardData = {
      image,
      brand,
      hasImage,
      type: 'Carousel_Brands',
      title: brand.summary,
      enableImageFadeIn,
    }
  }

  const elId = elementId || useComponentId(`${cardData.type}-card`)

  return (
    <CarouselCardWrapper
      hasAudience={hasAudiences}
      className={fixAudiences(audiences)}
      isNext={!isActive}
      isLast={isLast}>
      <Card {...cardData} elementId={elId} />
    </CarouselCardWrapper>
  )
}

CarouselCard.propTypes = {
  elementId: PropTypes.string,
  image: PropTypes.shape({
    altText: PropTypes.string,
    headline: PropTypes.string,
    portrait: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
      }),
    }),
  }),
  product: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    // currency: PropTypes.string,
    description: PropTypes.string.isRequired,
    locale: PropTypes.string,
    rrpPrice: PropTypes.number,
    salePrice: PropTypes.number,
    villagePrice: PropTypes.number,
    audiences: PropTypes.string,
  }),
  article: PropTypes.shape({
    eyebrow: PropTypes.string,
    url: PropTypes.string,
    publishDate: PropTypes.string,
    heading: PropTypes.string,
  }),
  service: PropTypes.shape({
    eyebrow: PropTypes.string,
    benefit: PropTypes.string,
    bodyCopy: PropTypes.string,
    heading: PropTypes.string,
    url: PropTypes.string,
    external: PropTypes.bool,
  }),
  offer: PropTypes.shape({
    eyebrow: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    offerRunStartDate: PropTypes.string.isRequired,
    offerRunFinishDate: PropTypes.string.isRequired,
    offerExpirationLabel: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    audiences: PropTypes.string,
    componentHeadline: PropTypes.string,
  }),
  brand: PropTypes.shape({
    summary: PropTypes.string,
    logo: PropTypes.shape({
      code: PropTypes.shape({ code: PropTypes.string }),
    }),
  }),
  info: PropTypes.shape({
    bodyCopy: PropTypes.string,
    heading: PropTypes.string,
  }),
  currentSlide: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isSmall: PropTypes.bool,
  onClick: PropTypes.func,
  hasImage: PropTypes.bool,
  isLast: PropTypes.bool,
  onclickProductModal: PropTypes.func,
  enableImageFadeIn: PropTypes.bool,
  rtl: PropTypes.bool,
  isColoredBg: PropTypes.bool,
  background: PropTypes.string,
}

CarouselCard.defaultProps = {
  elementId: null,
  product: null,
  article: null,
  service: null,
  offer: null,
  brand: null,
  info: null,
  isSmall: false,
  onClick: () => {},
  hasImage: false,
  isLast: false,
  image: null,
  onclickProductModal: () => {},
  enableImageFadeIn: false,
  rtl: null,
  isColoredBg: false,
  background: 'Green',
}

export default CarouselCard
